// @flow
import React from 'react';
import {Input, Label} from 'reactstrap'
import AbstractField from "./AbstractField";

// TODO NOPEPARTS - Nelze AbstractField / addony
class CheckboxField extends AbstractField {
    render() {
        const {label, disabled, addonsBefore, value, addonsAfter, onClick, ...props} = this.props;

        let field;
        if (label) {
            field = <Label check className={disabled ? "disabled" : ""} onClick={onClick}>
                <Input type="checkbox" disabled={disabled} checked={value} onClick={onClick} {...props}/>&nbsp;{label}
            </Label>;
        } else {
            field = <Label check className={disabled ? "disabled" : ""} onClick={onClick}>
                <Input type="checkbox" disabled={disabled} checked={value} onClick={onClick} {...props}/>
            </Label>;
        }

        return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
    }
}
export default CheckboxField;
